export default __webpack_public_path__ + "static/media/judge-asks.bbc0a8d2.png";